export enum ValidationAppliesToEnum {
    section = 'Section',
    page = 'Page'
}

export enum ValidationTypeEnum {
    Unknown = 0,
    Condition = 1,
    Lambda = 2
}